import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import GameService from '../../services/game.service';
// import { allMyStaticResults } from '../../data/StaticData';

export const fetchAllResults = createAsyncThunk(
  'result/fetchAllResults',
  async (args = {}, { rejectWithValue }) => {
    try {
      const response = await GameService.allMyResultResult(args);
      return response;
    } catch (error) {
      console.error("Error fetching game history:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const resultSlice = createSlice({
  name: 'result',
initialState: {
  data: null,
  status: 'idle', // idle | loading | success | failed
  error: null
},
  reducers: {
    clearGameHistory: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllResults.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchAllResults.fulfilled, (state, action) => {
        state.status = 'success';
        state.data = action.payload;
      })
      .addCase(fetchAllResults.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  }
});

export const { clearGameHistory } = resultSlice.actions;
export default resultSlice.reducer;